var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowLeftBold = function SvgArrowLeftBold(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m.578 9.39 6 6.024a1.993 1.993 0 0 0 2.824-.002 2.01 2.01 0 0 0-.002-2.836L6.82 9.977H14c.53 0 1.04-.211 1.414-.588a2.01 2.01 0 0 0 0-2.84A2 2 0 0 0 14 5.962H6.82L9.4 3.366A2.013 2.013 0 0 0 9.343.59 1.996 1.996 0 0 0 6.578.525l-6 6.024a2.03 2.03 0 0 0 0 2.838z"
  })));
};
export default SvgArrowLeftBold;